import React from "react";

interface TranscriptionCardProps {
  title: string;
  wordCount: number;
  date?: string;
  onSelect?: () => void;
}
const PenSvg = () => {
  return (
    <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1 12L8.94108 4.14573M2.64087 10.5373L2.92448 7.73223L9.73112 1H12V3.24408L5.19336 10.5373H2.64087Z" stroke="black" strokeWidth="0.5" />
    </svg>
  )

}
const TranscriptionCard: React.FC<TranscriptionCardProps> = ({
  title,
  wordCount,
  date,
  onSelect,
}) => {
  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      onSelect?.();
    }
  };

  return (
    <button
      className="bg-white rounded-xl border border-gray-200 shadow-sm cursor-pointer relative w-full focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50 hover:shadow-md transition-shadow"
      style={{ aspectRatio: '16/9' }}
      onClick={onSelect}
      onKeyDown={handleKeyDown}
      disabled={!onSelect}
      type="button"
      aria-label={`Select transcription: ${title}`}
    >
      {/* Top left - Word count */}
      <div className="absolute top-3 left-3 flex items-center gap-1 bg-red-100 text-gray-800 text-xs rounded-full px-2 py-0.5">
        <p className="">{wordCount.toLocaleString()}</p>
        <span className="text-[5px]">
          <PenSvg />
        </span>
      </div>

      {/* Center - Title */}
      <div className="w-full h-full flex items-center justify-center">
        <div className="bg-[#EFF4FF] rounded-full px-6 py-2">
          <p className="text-gray-700 text-lg font-medium">{title}</p>
        </div>
      </div>

      {/* Bottom right - Date */}
      <div className="absolute bottom-3 right-3 bg-red-100 text-gray-800 text-xs font-medium rounded-full px-2 py-0.5">
        {date?.toUpperCase()}
      </div>
    </button>
  );
};

export default TranscriptionCard;
